import React from 'react';
import Chart from 'react-apexcharts';

const STAGES = ['upload', 'collect-worker', 'mission-aggregator', 'mission-processor'];

/**
 * groupDataByDay:
 *  - Finds all unique days
 *  - For each stage, creates an array of total_count values
 *    aligned with those days (0 if missing)
 */
function groupDataByDay(apiData) {
  const records = apiData.results || [];

  // 1) Gather all unique days, sorted chronologically
  const allDays = Array.from(new Set(records.map((r) => r.day))).sort(
    (a, b) => new Date(a) - new Date(b)
  );

  // 2) Build a series for each stage
  const series = STAGES.map((stage) => {
    const dataArray = allDays.map((day) => {
      const found = records.find((r) => r.day === day && r.stage === stage);
      return found ? found.total_count : 0;
    });
    return {
      name: stage,
      data: dataArray,
    };
  });

  return { categories: allDays, series };
}

const InvocationsBarChart = ({ data }) => {
  const { categories, series } = groupDataByDay(data);

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: true },
    },
    title: {
      text: 'Pipeline Invocations per Day',
      align: 'center',
    },
    xaxis: {
      categories,
      title: { text: 'Day' },
    },
    yaxis: {
      title: { text: 'Invocation Count' },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%', // Adjust for spacing
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    legend: {
      position: 'bottom',
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <div style={{ marginBottom: '2rem' }}>
      <Chart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default InvocationsBarChart;
